import * as React from 'react';
import '../css/channel-cell.sass';
import Anchor from './Anchor';

interface ChannelCellProps {
  callLetter: string;
  logoUrl?: string;
  name?: string;
  number?: string;
  label?: string;
  setRef?: any;
  theme?: 'night' | 'day';
}

export default function ChannelCell(props: ChannelCellProps) {
  const { label = 'Ch. ', theme = 'day' } = props;

  return (
    <div className={`channel-cell ${theme}`} key={props.callLetter}>
      <Anchor
        arialabel={props.name}
        id={props.callLetter}
        href={`/station/${props.callLetter}`}
      >
        {props.logoUrl && <img alt="" src={props.logoUrl} />}
        {props.name && <div className="name">{props.name}</div>}
      </Anchor>
      {props.number && (
        <span className="number">{`${label}${props.number}`}</span>
      )}
    </div>
  );
}
